import { IdentifierDTO } from '@zazume/zzm-base';
import { DateVO } from '@zazume/zzm-utils';

import { RelatedModelType, DocumentType } from '#/models';

export class DocumentUploadLinksCreateRequest {
  private readonly relatedModelId: IdentifierDTO;
  private readonly relatedModelType: RelatedModelType;
  private readonly type: DocumentType;
  private readonly expiresAt: Date;
  private readonly description?: string;
  private readonly withMetadataModelUpdate?: boolean;
  private readonly withMultipleUploads?: boolean;

  constructor(
    relatedModelId: IdentifierDTO,
    relatedModelType: RelatedModelType,
    type: DocumentType,
    expiresAt: Date,
    description?: string,
    withMetadataModelUpdate?: boolean,
    withMultipleUploads?: boolean
  ) {
    this.relatedModelId = relatedModelId;
    this.relatedModelType = relatedModelType;
    this.type = type;
    this.expiresAt = expiresAt;
    this.description = description;
    this.withMetadataModelUpdate = withMetadataModelUpdate;
    this.withMultipleUploads = withMultipleUploads;
  }

  build() {
    return {
      relatedModelId: this.relatedModelId,
      relatedModelType: this.relatedModelType,
      type: this.type,
      expiresAt: DateVO.fromPrimitive(this.expiresAt).toPrimitive(),
      description: this.description,
      withMetadataModelUpdate: this.withMetadataModelUpdate,
      withMultipleUploads: this.withMultipleUploads
    };
  }
}
